<template>
    <div class="igc-playbook">
        <div class="ig--wrapper"
            :style="{ 'background': mBackground(17, 'bottom') }">
            <!-- <div class="ig--user">
                <div class="ig--avatar"
                    :style="{ 'background-image': `url(${ imagePath }logo.png)` }"></div>
                <div class="ig--info">
                    <div class="ig--nickname">
                        <div
                            :style="{ 'color': mColor(1) }">{{ playbook.sAuthor }}</div>
                        <div class="ig--tag"
                            :style="{ 'border-color': mColor(11), 'color': mColor(11) }">热门</div>
                    </div>
                    <div class="ig--time"
                        :style="{ 'color': mColor(3) }">{{ playbook.sIdxTime }}</div>
                </div>
            </div> -->
            <router-link class="ig--content"
                :to="{ name: playbook.iInfoType == 1 ? 'detail-news' : 'detail-video', params: { id: playbook.iId } }"
                 v-dmp="{action:'click,pop', targetid: playbook.iId, targettype: 'moment', title: playbook.sTitle, from: 'ingame'}"
                >
                <div class="ig--poster">
                    <div v-if="playbook.iInfoType == 2" class="ig--icon"></div>
                    <sui-image :src="mImageView(playbook.sIMG, '/1/w/315/h/210')"></sui-image>
                </div>
                <div class="ig--info">
                    <div class="ig--title ig-style--ellipsis"
                        :style="{ 'color': mColor(1) }">{{ playbook.sTitle }}</div>
                    <div class="ig--num">
                        <sui-icon class="ig--icon"
                            name="eye-outline"
                            :fill="mColor(3)"></sui-icon>
                        <div class="ig--text"
                            :style="{ 'color': mColor(3) }">{{ playbook.iTotalPlay }}</div>
                        <sui-icon class="ig--icon"
                            name="message-outline"
                            v-if="playbook.igNum"
                            :fill="mColor(3)"></sui-icon>
                        <div class="ig--text"
                            v-if="playbook.igNum"
                            :style="{ 'color': mColor(3) }">{{ playbook.igNum.comment }}</div>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import mCore from '../../scripts/mixins/core'

export default {
    name: 'igc-playbook',

    mixins: [mCore],

    props: {
        playbook: {
            type: Object,
            required: true
        }
    },

    computed: {
        imagePath() {
            return this.$store.getters['global/imagePath']
        }
    }
}
</script>

<style lang="postcss">
.igc-playbook {
    padding: 0 20px;
    .ig--wrapper {
        padding: 20px 0;
        .ig--user {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .ig--avatar {
                width: 56px;
                height: 56px;
                margin-right: 12px;
                border-radius: 50%;
                background: no-repeat center / contain;
            }
            .ig--info {
                .ig--nickname {
                    display: flex;
                    align-items: center;
                    font-size: 28px;
                    .ig--tag {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        box-sizing: border-box;
                        height: 24px;
                        margin-left: 8px;
                        padding: 0 8px;
                        border: 1px solid;
                        border-radius: 2px;
                        font-size: 18px;
                    }
                }
                .ig--time {
                    font-size: 18px;
                }
            }
        }
        .ig--content {
            display: flex;
            .ig--poster {
                flex: none;
                position: relative;
                width: 180px;
                height: 120px;
                margin-right: 20px;
                .ig--icon {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    z-index: 1;
                    width: 54px;
                    height: 54px;
                    background: url(../../images/play.png) no-repeat center / contain;
                    transform: translate3d(-50%, -50%, 0);
                }
                .sui-image {
                    width: 100%;
                    height: 100%;
                }
            }
            .ig--info {
                flex: auto;
                overflow: hidden;
                font-size: 32px;
                .ig--num {
                    display: flex;
                    align-items: center;
                    margin-top: 12px;
                    font-size: 24px;
                    .ig--icon {
                        width: 34px;
                        height: 34px;
                        margin-right: 6px;
                    }
                    .ig--text {
                        margin-right: 24px;
                    }
                }
            }
        }
    }
}
</style>
